import { format, parseISO } from 'date-fns';
import { MinMax } from 'common/table/types/TableV3';
import { convertBirthDateRangeToAgeRange } from 'modules/candidate-profile/tables/maps/convertAgeRange';
import {
  CandidateFilterValueType,
  CandidateRangeFilter,
  RangeFilterSettings
} from 'modules/candidate-profile/types/CandidateSearchFilter';

const formatCalendarDay = (value: number | string): string => {
  try {
    return format(parseISO(String(value).slice(0, 10)), 'd MMM yyyy');
  } catch {
    return String(value);
  }
};

const describeNumberRange = (
  { min, max }: MinMax<number | string>,
  unit?: string
): string => {
  const last = max ?? min;
  const word = unit === 'years' && Number(last) === 1 ? 'year' : unit;
  const suffix = word ? ` ${word}` : '';
  if (min !== undefined && min === max) return `Exactly ${min}${suffix}`;
  if (min !== undefined && max !== undefined) {
    return `Between ${min} and ${max}${suffix}`;
  }
  if (min !== undefined) return `More than or equal to ${min}${suffix}`;
  if (max !== undefined) return `Less than or equal to ${max}${suffix}`;

  return '';
};

const describeDateRange = ({ min, max }: MinMax<number | string>): string => {
  if (
    min !== undefined &&
    max !== undefined &&
    formatCalendarDay(min) === formatCalendarDay(max)
  ) {
    return `Exactly ${formatCalendarDay(min)}`;
  }
  if (min !== undefined && max !== undefined) {
    return `Between ${formatCalendarDay(min)} and ${formatCalendarDay(max)}`;
  }
  if (min !== undefined) return `After ${formatCalendarDay(min)}`;
  if (max !== undefined) return `Before ${formatCalendarDay(max)}`;

  return '';
};

export const describeRangeConditionForChip = (
  filter: CandidateRangeFilter,
  range?: RangeFilterSettings
): string => {
  if (filter.type !== CandidateFilterValueType.DATE) {
    return describeNumberRange(filter, range?.unit);
  }
  if (!range?.showsAge) return describeDateRange(filter);

  return (
    describeNumberRange(
      convertBirthDateRangeToAgeRange({
        min: filter.min === undefined ? undefined : String(filter.min),
        max: filter.max === undefined ? undefined : String(filter.max)
      }),
      range.unit
    ) || describeDateRange(filter)
  );
};
